var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTriangle = function SvgTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 8,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#triangle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.496 2.744c-1.187-1.781-3.805-1.781-4.992 0L31 8h12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.496 2.744c-1.187-1.781-3.805-1.781-4.992 0L31 8h12z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.06,
    d: "M39.08 3.021a2.5 2.5 0 0 0-4.16 0L31.935 7.5h10.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m41.8 8-3.136-4.701a2 2 0 0 0-3.328 0L32.2 8z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "triangle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 8h74V0H0z"
  })))));
};
export default SvgTriangle;